import axios from '../../service/index'
import React, { Component } from 'react'
import { Button, Divider, Table, Modal, message, Form, Input } from 'antd'
import { DndProvider, DragSource, DropTarget } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import update from 'react-addons-update';
const FormItem = Form.Item;
let dragingIndex = -1;
class BodyRow extends React.Component {
	render() {
		const { isOver, connectDragSource, connectDropTarget, moveRow, ...restProps } = this.props;
		const style = { ...restProps.style, cursor: 'move' };

		let { className } = restProps;
		if (isOver) {
			if (restProps.index > dragingIndex) {
				className += ' drop-over-downward';
			}
			if (restProps.index < dragingIndex) {
				className += ' drop-over-upward';
			}
		}

		return connectDragSource(
			connectDropTarget(<tr {...restProps} className={className} style={style} />),
		);
	}
}
const rowSource = {
	beginDrag(props) {
		dragingIndex = props.index;
		return {
			index: props.index,
		};
	},
};
const rowTarget = {
	drop(props, monitor) {
		const dragIndex = monitor.getItem().index;
		const hoverIndex = props.index;
		if (dragIndex === hoverIndex) {
			return;
		}
		props.moveRow(dragIndex, hoverIndex);
		monitor.getItem().index = hoverIndex;
	},
};
const DragableBodyRow = DropTarget('row', rowTarget, (connect, monitor) => ({
	connectDropTarget: connect.dropTarget(),
	isOver: monitor.isOver(),
}))(
	DragSource('row', rowSource, connect => ({
		connectDragSource: connect.dragSource(),
	}))(BodyRow),
);
class Stage extends Component {
	constructor(props) {
		super(props)
		this.state = {
			total: 0,
			strageId: '',
			modelTitle: '新增阶段',
			visible: false,
			releaseVisible: false,
			url: '',
			strageName:'',
			name: '',
			subjectIcon: null,
			changeSwitch: false,
			searchData: {
				status: '',
				pageNum: 1,
				pageSize: 20
			},
			columns: [
				{
					title: '阶段名称',
					dataIndex: 'name',
					key: 'name',
					align: 'center'
				},
				{
					title: '课程数量',
					dataIndex: 'num',
					key: 'num',
					align: 'center'
				},
				{
					title: '创建人',
					dataIndex: 'admin',
					key: 'admin',
					align: 'center'
				},
				{
					title: '创建时间',
					dataIndex: 'createTime',
					key: 'createTime',
					align: 'center'
				},
				
				{
					title: '操作',
					key: 'operation',
					align: 'center',
					render: (record) => <div>
						<span style={{ marginRight: '15px', color: '#277FFF', cursor: 'pointer' }} onClick={() => {
							// console.log(record)
							this.setState({
								strageId: record.id,
								visible: true,
								modelTitle: '编辑阶段',
								strageName: record.name,
								subjectIcon: {
									uid: record.uploadUid,
									type: record.uploadType,
									url: record.pic,
									name: record.uploadUid
								},

							})
						}}>编辑</span>
						<span style={{marginRight:'15px',color: '#277FFF', cursor: 'pointer'}} onClick={()=>{
						
							sessionStorage.setItem('stageId',record.id)
							sessionStorage.setItem('stageName',record.name)
							// this.props.history.push('/Course')
							this.props.history.push('/Course')
						}}>课程</span>
						<span style={{ color: '#277FFF', cursor: 'pointer' }} onClick={() => {
							Modal.confirm({
								title: '删除阶段',
								okText: "确认",
								cancelText: "取消",
								content: (
									<div>
										<p>阶段删除后下属课程会跟随删除且不可恢复，请谨慎操作！确定要删除吗？</p>
									</div>
								),
								onOk: () => {
									this.delStage(record.id)
								},
							});
						}}>删除</span>
					</div>
				},
			],
			subjecListData: [],
			notChanged: []

		}
	}
	
	async getStageList() {
		axios.post('stageController/getList', {
			subjectId:sessionStorage.getItem('subjectId'),
			...this.state.searchData,
			name: this.state.name
		}).then(res => {
			if (res.data.code === '200') {
				this.setState({
					total: res.data.data.total,
					subjecListData: res.data.data.list,
					notChanged: res.data.data.list,
					searchData: {
						pageNum: res.data.data.pageNum,
						pageSize: res.data.data.pageSize
					}
				})
			}
		})
	}
	delStage(id) {
		axios.get(`stageController/del/${id}`).then(res => {
			if(res.data.code === '200') {
				message.success('删除阶段成功')
				this.getStageList()
			}else {
				message.success(res.data.msg)
			}
		})
	}
	handleOk = (e) => {
		let _this = this
		this.props.form.validateFields((err, values) => {
			// console.log(values)
			if(!err) {
				let subjectId= sessionStorage.getItem('subjectId')
				if(this.state.modelTitle === '新增阶段'){
					axios.post('stageController/add', {
						subjectId: +subjectId,
						name: values.name,
					}).then(res => {
						if (res.data.code === '200') {
							message.success('添加成功')
							this.props.form.resetFields();
							this.setState({ visible: false })
							this.getStageList()
						} else {
							message.error(res.data.msg)
						}
					})
				}else {
					axios.post('stageController/update', {
						subjectId: +subjectId,
						id: _this.state.strageId,
						name: values.name
					}).then(res => {
						if (res.data.code === '200') {
							message.success('修改成功')
							_this.props.form.resetFields();
							_this.setState({ visible: false })
							_this.getStageList()
						} else {
							message.error(res.data.msg)
						}
					})
				}
				
			}
			
		});
	}
	componentDidMount() {
		this.getStageList()
	}
	showModal() {
		this.setState({ visible: true, modelTitle: '新增阶段', subjectIcon: '' })
	}
	getUploadUrl = v => {
		this.setState({
			uploadUrl: v
		})
	}
	components = {
		body: {
			row: DragableBodyRow,
		},
	};
	moveRow = (dragIndex, hoverIndex) => {
		const { subjecListData } = this.state;
		const dragRow = subjecListData[dragIndex];
		this.setState(
			update(this.state, {
				subjecListData: {
					$splice: [[dragIndex, 1], [hoverIndex, 0, dragRow]],
				},
			}),
		);
		let oldSort = []
		for (let i = 0; i < this.state.notChanged.length; i++) {
			oldSort.push({ sort: this.state.notChanged[i].sort, id: this.state.subjecListData[i].id })
		}
		axios.post('stageController/updateSort',oldSort).then(res => {
			// console.log(res)
			if(res.data.code === '200' )
			oldSort = []
		})
		

	};
	render() {
		const { visible, columns, subjecListData, modelTitle, strageName,total } = this.state;
		const { getFieldDecorator } = this.props.form;
		const pagination = {
			showSizeChanger: true,
			total: total,
			pageSizeOptions: ['20', '40', '80', '100'],
			pageSize: this.state.searchData.pageSize,
			showTotal: () => `共 ${total} 条`,
			onShowSizeChange: (current, pageSize) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				searchData.pageSize = pageSize
				this.getStageList(searchData)
			},
			onChange: (current) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				this.getStageList(searchData)
			},
		}
		return (
			<div>
				<div style={{display: 'flex',justifyContent: 'space-between'}}>
					<span style={{ display: 'flex', alignItems: 'center', fontSize: '18px', fontWeight: '600' }}>阶段管理</span>
					<span className="my-button-txt" onClick={()=>{
						sessionStorage.setItem('stageId','')
						this.props.history.push('/subjectController')
					}}>返回上一级</span>
				</div>
				
				<Divider />
				<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
					<div>
						<Input allowClear value={this.state.name} style={{ width: '260px', height: '40px', marginRight: '20px' }} 
						placeholder="请输入阶段名称"
						onChange={(e)=>{
							this.setState({
									name: e.target.value
								
							})
						}}
						></Input>
						<Button className='my-button-primary' type='primary' onClick={() => {
							this.getStageList()
						}}>搜索</Button>
						<span className="my-button-txt" style={{marginLeft: '20px'}} onClick={()=> {
							this.setState({
								name: ''
							},()=>{
								this.getStageList()
							})
						}}>重置</span>
					</div>
					<Button className='my-button-primary' type='primary' onClick={() => { this.showModal() }}>新增阶段</Button>
				</div>
				<DndProvider backend={HTML5Backend}>
					<Table
						dataSource={subjecListData}
						columns={columns}
						components={this.components}
						rowKey={record => record.id}
						rowClassName={(record, index) => (index % 2 !== 0 ? 'table-line' : '')}
						onRow={(record, index) => ({
							index,
							moveRow: this.moveRow,
						})}
						pagination={pagination}
					/>
				</DndProvider>
				<Modal
					getContainer={true}
					title={modelTitle}
					maskClosable={false}
					okText="确认"
					cancelText="取消"
					visible={visible}
					onOk={() => { this.handleOk() }}
					onCancel={() => { this.setState({ visible: false }) }}
					destroyOnClose
					width={400}
				>
					<Form labelCol={{ span: 5 }} wrapperCol={{ span: 18 }} onSubmit={this.handleOk}>
						<FormItem label={"阶段名称"}>
							{getFieldDecorator('name', {
								rules: [{ required: true, message: '请输入阶段名称!'},{max: 50, message: '最多输入50个字'}],
								initialValue:modelTitle==='编辑阶段'? strageName: ''
							})(
								<Input placeholder='请输入阶段名称' />
							)}
						</FormItem>
					</Form>
				</Modal>
			</div>
		)
	}
}

export default Form.create()(Stage)